import { getCookie } from '~/utils/cookie.utils'

import AnalyticsEvents_V2 from '../analyticsGA4'
import { PortalProducts, Labels, TrafficType } from '../types/analytics.type'
import { TMP_EVENT_NAME } from '../constant'

import { AccountEvents, LoginType } from './accountEvents.types'

class AccountAnalytics extends AnalyticsEvents_V2 {
  public constructor() {
    super(PortalProducts.ACCOUNT)
  }

  public logResendEmail({ successful, errorCode }: { successful: boolean; errorCode?: string }): void {
    this.logEvent({
      event: AccountEvents.RESEND_VERIFICATION_EMAIL,
      status: successful ? Labels.SUCCESSFUL : errorCode ?? Labels.UNSUCCESSFUL,
    })
  }

  public logEmailVerification({ successful, errorCode }: { successful: boolean; errorCode?: string }): void {
    this.logEvent({
      event: AccountEvents.VERIFY_EMAIL,
      status: successful ? Labels.SUCCESSFUL : errorCode ?? Labels.UNSUCCESSFUL,
    })
  }

  public logSignup(user_id: number, shouldMarkExternal: boolean): void {
    const traffic_type = shouldMarkExternal ? TrafficType.external : TrafficType.internal
    const eventId = getCookie(TMP_EVENT_NAME)

    this.logEvent({
      event: AccountEvents.CREATE_NEW_ACCOUNT,
      eventId,
      status: Labels.SUCCESSFUL,
      traffic_type,
      user_id,
    })
  }

  public logSignIn(loginType: LoginType, user_id: number, shouldMarkExternal: boolean): void {
    let loginMethod: AccountEvents
    const traffic_type = shouldMarkExternal ? TrafficType.external : TrafficType.internal

    switch (loginType) {
      case LoginType.FACEBOOK:
        loginMethod = AccountEvents.LOGIN_FACEBOOK
        break

      case LoginType.GOOGLE:
        loginMethod = AccountEvents.LOGIN_GOOGLE
        break

      default:
        loginMethod = AccountEvents.LOGIN_EMAIL
        break
    }

    this.logEvent({ event: AccountEvents.LOGIN, method: loginMethod, user_id, traffic_type })
  }

  public logLogOut(userId?: string): void {
    this.logEvent({
      event: AccountEvents.LOGOUT,
      status: Labels.SUCCESSFUL,
      user_id: userId,
    })
  }

  public logAuthenticateWithToken(shouldMarkExternal?: boolean): void {
    const traffic_type = shouldMarkExternal ? TrafficType.external : TrafficType.internal

    this.logEvent({
      event: AccountEvents.AUTH_TOKEN,
      status: Labels.SUCCESSFUL,
      traffic_type,
    })
  }

  public logSneakPreview(): void {
    this.logEvent({
      event: AccountEvents.CLICKED_SNEAK_PREVIEW,
      status: Labels.SUCCESSFUL,
    })
  }
}

export default new AccountAnalytics()
